import React, { useState } from 'react';
import { ArrowDownTrayIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { shieldFetch } from '../services/api';

const apiUrl = process.env.REACT_APP_URL_LOCAL || '';

const LockedVehiclePanel = ({ vehicle, user }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [downloading, setDownloading] = useState(false);

  const download = async (event) => {
    event.preventDefault();
    setDownloading(true);
    setError('');
    try {
      const response = await shieldFetch(`${apiUrl}/api/vehicule/${user.UtilisateurID}/${vehicle.VehiculeID}/download-folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.error || 'Téléchargement impossible.');
      }
      const blob = await response.blob();
      const disposition = response.headers.get('Content-Disposition') || '';
      const filename = disposition.match(/filename="?([^";]+)"?/)?.[1] || `vehicule-${vehicle.VehiculeID}-dossier.zip`;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      setPassword('');
    } catch (downloadError) {
      setError(downloadError.message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <section className="mx-auto max-w-2xl rounded-xl border border-amber-500/30 bg-slate-950/75 p-7 text-slate-100 shadow-2xl shadow-amber-950/20">
      <div className="flex items-start gap-4">
        <span className="grid size-12 shrink-0 place-items-center rounded-full bg-amber-500/10 text-amber-200"><LockClosedIcon className="size-6" /></span>
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-amber-300">Véhicule conservé</p>
          <h1 className="mt-1 text-2xl font-black text-white">{vehicle.Nom}</h1>
          <p className="mt-3 text-sm leading-6 text-slate-300">Ce véhicule dépasse la limite actuelle du compte. Ses données ne sont pas consultables ni modifiables, mais elles restent conservées et téléchargeables.</p>
        </div>
      </div>

      <form onSubmit={download} className="mt-7 rounded-lg border border-white/10 bg-slate-900/60 p-5">
        <label className="block text-sm font-semibold text-slate-300">Confirmez le téléchargement avec votre mot de passe</label>
        <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="mt-2 w-full rounded-lg border border-sky-500/30 bg-slate-950 px-3 py-2 text-white outline-none focus:border-sky-400" required />
        {error && <p className="mt-2 text-sm text-rose-300">{error}</p>}
        <button type="submit" disabled={downloading} className="mt-4 inline-flex items-center gap-2 rounded-lg bg-sky-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-sky-500 disabled:opacity-50">
          <ArrowDownTrayIcon className="size-5" />
          {downloading ? 'Préparation…' : 'Télécharger toutes les données'}
        </button>
      </form>
    </section>
  );
};

export default LockedVehiclePanel;
